export default __webpack_public_path__ + "static/projectsBg-677786c0aaf0a7a76ea4704308230e3d.svg";